import { defineStore } from "pinia";
import { ref } from "vue";
const useSystemSettingsStore = defineStore("systemSettings", () => {
  const systemSettings = ref({});
  const setSystemSettingValue = (key, value) => {
    systemSettings.value[key] = value;
  };
  const getSystemSettingValue = (key) => {
    return systemSettings.value[key];
  };
  const hasSystemSetting = (key) => {
    return key in systemSettings.value;
  };
  return {
    systemSettings,
    setSystemSettingValue,
    getSystemSettingValue,
    hasSystemSetting
  };
});
export {
  useSystemSettingsStore
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3lzdGVtLXNldHRpbmdzLmpzIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc3RvcmUvc3lzdGVtLXNldHRpbmdzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGRlZmluZVN0b3JlIH0gZnJvbSBcInBpbmlhXCI7XG5cbmV4cG9ydCBjb25zdCB1c2VTeXN0ZW1TZXR0aW5nc1N0b3JlID0gZGVmaW5lU3RvcmUoXCJzeXN0ZW1TZXR0aW5nc1wiLCAoKSA9PiB7XG5cdGNvbnN0IHN5c3RlbVNldHRpbmdzID0gcmVmKHt9KTtcblxuXHRjb25zdCBzZXRTeXN0ZW1TZXR0aW5nVmFsdWUgPSAoa2V5LCB2YWx1ZSkgPT4ge1xuXHRcdHN5c3RlbVNldHRpbmdzLnZhbHVlW2tleV0gPSB2YWx1ZTtcblx0fTtcblxuXHRjb25zdCBnZXRTeXN0ZW1TZXR0aW5nVmFsdWUgPSAoa2V5KSA9PiB7XG5cdFx0cmV0dXJuIHN5c3RlbVNldHRpbmdzLnZhbHVlW2tleV07XG5cdH07XG5cblx0Y29uc3QgaGFzU3lzdGVtU2V0dGluZyA9IChrZXkpID0+IHtcblx0XHRyZXR1cm4ga2V5IGluIHN5c3RlbVNldHRpbmdzLnZhbHVlO1xuXHR9O1xuXG5cdHJldHVybiB7XG5cdFx0c3lzdGVtU2V0dGluZ3MsXG5cdFx0c2V0U3lzdGVtU2V0dGluZ1ZhbHVlLFxuXHRcdGdldFN5c3RlbVNldHRpbmdWYWx1ZSxcblx0XHRoYXNTeXN0ZW1TZXR0aW5nLFxuXHR9O1xufSk7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFWSxNQUFDLHlCQUF5QixZQUFZLGtCQUFrQixNQUFNO0FBQ3pFLFFBQU0saUJBQWlCLElBQUksRUFBRTtBQUU3QixRQUFNLHdCQUF3QixDQUFDLEtBQUssVUFBVTtBQUM3QyxtQkFBZSxNQUFNLEdBQUcsSUFBSTtBQUFBLEVBQzVCO0FBRUQsUUFBTSx3QkFBd0IsQ0FBQyxRQUFRO0FBQ3RDLFdBQU8sZUFBZSxNQUFNLEdBQUc7QUFBQSxFQUMvQjtBQUVELFFBQU0sbUJBQW1CLENBQUMsUUFBUTtBQUNqQyxXQUFPLE9BQU8sZUFBZTtBQUFBLEVBQzdCO0FBRUQsU0FBTztBQUFBLElBQ047QUFBQSxJQUNBO0FBQUEsSUFDQTtBQUFBLElBQ0E7QUFBQSxFQUNBO0FBQ0YsQ0FBQzsifQ==
